export const userVerificationImage = (state) => { return state.userVerificationImage };
